import { hasCapability, type User } from "../base";

export const roofScope = {
  read: (user: User) => hasCapability(user, "roofScope.read"),
  update: (user: User) => hasCapability(user, "roofScope.update"),
};
